import type { CSSProperties, PropsWithChildren, ReactNode } from 'react';
import type { To } from 'react-router';

import styles from './Page.module.css';

import { Header } from 'App/shared/Header';
import { Helmet } from 'App/shared/Helmet';
import { useCurrentLanguage } from 'hooks/useCurrentLanguage';
import { useScrollableHeader } from 'providers/ScrollableHeaderProvider';

interface Props {
  defaultDocumentTitle?: string;
  documentTitle?: string | string[];
  header?: ReactNode;
  titleTemplate?: string;
  notification?: ReactNode;
  actions?: ReactNode;
  note?: string | number;
  backlink?: { to: To; text: string };
  subTitle?: ReactNode;
}

const defaultTitleTemplate = 'UvA - GLASS: %s';

export const getTitle = (documentTitle: string | string[], template = defaultTitleTemplate) => {
  if (Array.isArray(documentTitle)) {
    return documentTitle.reduce((acc, val) => acc.replace(/%s/, val), template);
  }

  return template.replace(/%s/g, documentTitle);
};

export function Page(props: PropsWithChildren<Props>) {
  const {
    children,
    defaultDocumentTitle = '',
    documentTitle,
    header,
    notification,
    titleTemplate = defaultTitleTemplate,
  } = props;
  const currentLanguage = useCurrentLanguage();
  const { headerRoom } = useScrollableHeader();

  return (
    <div>
      <Helmet>
        <html lang={currentLanguage.toLocaleLowerCase()} />
        <title>{getTitle(documentTitle || defaultDocumentTitle, titleTemplate)}</title>
      </Helmet>

      {header || (
        <div className={styles['page__headerroom']} style={{ '--header-room': `${headerRoom}px` } as CSSProperties}>
          <Header />
        </div>
      )}

      {notification}

      <main>{children}</main>
    </div>
  );
}
